const { EVENTS, errorReason } = require('./productInsights');
const { consumeAuthCtaContext } = require('./authCtaContext');
const KEY = 'aiq_auth_measurement';
const MAX_AGE = 30 * 60 * 1000;

/** A returning login is not a registration. /me proves app access; refreshes never count. */
function createAuthInsights({ getAnalyticsConsent, isAnalyticsActive, subscribeAnalyticsConsent, insight, storage, eventTypes }) {
    function read() {
        try {
            if (getAnalyticsConsent() !== 'accepted') { storage.removeItem(KEY); return null; }
            const value = JSON.parse(storage.getItem(KEY) || 'null');
            if (!value || !Number.isFinite(value.at) || Date.now() - value.at > MAX_AGE) {
                storage.removeItem(KEY); return null;
            }
            return value;
        } catch { return null; }
    }
    function write(value) { try { storage.setItem(KEY, JSON.stringify(value)); } catch { /* Storage may be blocked. */ } }
    function flush() {
        const attempt = read();
        if (!attempt || !isAnalyticsActive()) return;
        if (attempt.returned) {
            insight(EVENTS.AUTH_RETURNED);
            attempt.returned = false;
            write(attempt);
        }
        if (attempt.ready || attempt.failed) {
            insight(attempt.ready ? EVENTS.AUTH_READY : EVENTS.AUTH_FAILED, { reason: attempt.failed, duration_ms: Date.now() - attempt.at });
            try { storage.removeItem(KEY); } catch { /* Best effort. */ }
        }
    }
    function recordProfile(ok, error) {
        const attempt = read();
        if (!attempt) return;
        write({ ...attempt, ready: ok, failed: ok ? undefined : errorReason(error) });
        flush();
    }
    function install(instance) {
        subscribeAnalyticsConsent(() => {
            if (!isAnalyticsActive()) { try { storage.removeItem(KEY); } catch { /* Best effort. */ } }
            else flush();
        });
        instance.addEventCallback(event => {
            if (event.eventType === eventTypes.LOGIN_START && isAnalyticsActive()) {
                // Use the same storage injected for auth measurement (eval mocks + browser sessionStorage).
                const cta = consumeAuthCtaContext(storage);
                write({ at: Date.now(), ...cta });
                insight(EVENTS.AUTH_STARTED, cta);
            } else if (event.eventType === eventTypes.LOGIN_SUCCESS) {
                const attempt = read();
                if (attempt) { write({ ...attempt, returned: true }); flush(); }
            } else if (event.eventType === eventTypes.LOGIN_FAILURE) recordProfile(false, event.error);
        });
    }
    return { install, recordProfile };
}
module.exports = { createAuthInsights };
